const md5_hex = require('js-md5');

class E3CheckPassword {
    constructor() {
        this.hash_string = "ey90YCq5o7yw8hLK";
    }

    check(password, checkingPassword) {
        return password === md5_hex(this.hash_string  + checkingPassword);
    }

}

export default E3CheckPassword
